<template>
  <PrescriptionResultPage :config="config" />
</template>

<script>
import PrescriptionResultPage from '@/components/smallComponents/PrescriptionResultPage.vue'

export default {
  components: { PrescriptionResultPage },
  data() {
    return {
      config: {
        pageTitle: '通用方信息确认',
        showSymptoms: false,
        showGanZhiLabel: false,
        priceApi: '/api/health/v1/granulesPrice',
        redirectRoute: '/GeneralPrescription',
        showMainTabCard: true,
      },
    }
  },
}
</script>
<style scoped>
</style>
